module.exports = __webpack_public_path__ + "img/tablet_cover_a.732ae10b.png";